import React from 'react';
import { ScrollLink } from './ScrollLink';
import '../styles/Vantagens.css';

function Vantagens() {
  return (
    <div className="vantagens-page">
      {/* Hero Section */}
      <section className="vantagens-hero">
        <div className="hero-content">
          <h1>Estude de Graça. Solicite seu Certificado Digital.</h1>
          <p className="hero-subtitle">
            Na ABRALIBER, acreditamos que a educação de qualidade deve ser para todos.
            Por isso, oferecemos cursos 100% gratuitos, elaborados por especialistas, com a opção de emissão de certificado digital de conclusão.
          </p>
        </div>
      </section>

      {/* Container Principal */}
      <div className="vantagens-container">
        {/* Por que escolher */}
        <section className="about-section">
          <div className="section-header">
            <h2>Por que escolher a ABRALIBER?</h2>
            <div className="section-divider"></div>
          </div>

          <div className="vantagens-grid">
            <div className="vantagem-card">
              <div className="vantagem-icon">📚</div>
              <div className="vantagem-content">
                <h3>Conteúdo de Qualidade</h3>
                <p>Cursos gratuitos com conteúdo de qualidade e aplicação prática, elaborados por especialistas na área.</p>
              </div>
            </div>

            <div className="vantagem-card">
              <div className="vantagem-icon">🕒</div>
              <div className="vantagem-content">
                <h3>Flexibilidade Total</h3>
                <p>Estude no seu ritmo, de qualquer lugar. Você tem total liberdade para organizar seus estudos como preferir.</p>
              </div>
            </div>

            <div className="vantagem-card">
              <div className="vantagem-icon">🏆</div>
              <div className="vantagem-content">
                <h3>Certificado Digital</h3>
                <p>Certificado válido para comprovação de curso livre, útil para enriquecer seu currículo, validar horas complementares conforme as regras da instituição e comprovar qualificação.</p>
              </div>
            </div>

            <div className="vantagem-card">
              <div className="vantagem-icon">💰</div>
              <div className="vantagem-content">
                <h3>Investimento Acessível</h3>
                <p>Investimento acessível apenas se desejar emitir o certificado. Todo o conteúdo é 100% gratuito.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Transforme seu tempo */}
        <section className="about-section">
          <div className="content-card transformacao-card">
            <h2>Transforme seu tempo livre em oportunidade!</h2>
            <p>
              Aprenda novas habilidades, fortaleça seu currículo e comprove seu conhecimento com um certificado digital de conclusão.
            </p>
          </div>
        </section>

        {/* Call to Action */}
        <section className="about-section">
          <div className="content-card cta-card">
            <h2>➡ Inscreva-se hoje e comece agora mesmo!</h2>
            <p>
              Não perca tempo! Comece sua jornada de aprendizado hoje mesmo e transforme seu futuro profissional.
            </p>
            <div className="cta-buttons">
              <ScrollLink to="/cursos" className="btn-primary">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Ver Cursos
              </ScrollLink>
              <ScrollLink to="/cadastro" className="btn-secondary">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="8.5" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="20" y1="8" x2="20" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="23" y1="11" x2="17" y2="11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Cadastrar-se
              </ScrollLink>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Vantagens;
